import styled from 'styled-components'
import { Theme } from 'styles/Themes'

interface Style {
  file?: boolean
  error?: string | boolean
}

export const UpImg = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 11px;
  font-weight: 400;
  line-height: 20px;
  margin-right: 0;
  height: 40px;
  width: 252px;
  max-width: 252px;
  padding: 10px 14px;
  box-sizing: border-box;
  cursor: pointer;
  border-radius: 5px;
  border: ${(props: Style) => {
    if (props.file) return `1px solid #DF7A58`
    if (props.error) return '1px solid #f60665'
    return '1px dashed #cccccc'
  }};
  background: #fdfdfd;
  /* &:hover {
    background: #8f888133;
  } */
  &:disabled {
    &::placeholder {
      color: #fff;
    }
    background: lightGray;
    border: 0;
  }

  .ui-img {
    position: relative;
    width: 19px;
    height: 19px;

    @media only screen and (min-width: 1441px) {
      width: 21px;
      height: 21px;
    }
  }

  .ui-input {
    display: none;
  }

  .upload-text {
    color: #757575;
    width: 100px;
    font-family: Inter;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    @media only screen and (min-width: 1441px) {
      font-size: 12px;
    }
  }

  .upload-info {
    color: #cccccc;
    text-align: right;
    font-family: Inter;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
  }
  @media only screen and (min-width: 1441px) {
    height: 45px;
    width: 284px;
    max-width: 284px;
    padding: 10px 14px;
    font-size: 12px;
  }
`
export const Image = styled.img`
  position: absolute;
  width: 19px;
  height: 19px;
  right: 14px;
  top: 10px;

  cursor: pointer;
  @media only screen and (min-width: 1441px) {
    width: 21px;
    height: 21px;
  }
`
